/** @format */

export const KEY_APP_NAME = "" + process.env.REACT_APP_NAME;
export const KEY_ASSISTANCE_MAIL = "produzione@infcom.it";
